module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"step":"Тестирование кандидата","next":"Далее","vacancyCreated":"Вакансия создана"}}')
  delete Component.options._Ctor
}
